import React from 'react';

export default () => (
  <svg version="1.1" viewBox="0 0 24 24" width="36" height="32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="m0.5 23.5h23" stroke="#05B87F" strokeLinecap="round" strokeLinejoin="round" />
      <polygon points="1.5 18.5 4.5 18.5 4.5 23.5 1.5 23.5" fill="#C0F2D6" />
      <polygon points="7.5 13.5 10.5 13.5 10.5 23.5 7.5 23.5" fill="#C0F2D6" />
      <polygon points="13.5 15.5 16.5 15.5 16.5 23.5 13.5 23.5" fill="#C0F2D6" />
      <polygon points="19.5 8.5 22.5 8.5 22.5 23.5 19.5 23.5" fill="#C0F2D6" />
      <polygon
        points="1.5 18.5 4.5 18.5 4.5 23.5 1.5 23.5"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="7.5 13.5 10.5 13.5 10.5 23.5 7.5 23.5"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="13.5 15.5 16.5 15.5 16.5 23.5 13.5 23.5"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="19.5 8.5 22.5 8.5 22.5 23.5 19.5 23.5"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m3.7071 10.793c0.39052 0.39052 0.39052 1.0237 0 1.4142-0.39052 0.39052-1.0237 0.39052-1.4142 0-0.39052-0.39052-0.39052-1.0237 0-1.4142 0.39052-0.39052 1.0237-0.39052 1.4142 0"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m9.7071 5.7929c0.39052 0.39052 0.39052 1.0237 0 1.4142-0.39052 0.39052-1.0237 0.39052-1.4142 0-0.39052-0.39052-0.39052-1.0237 0-1.4142 0.39052-0.39052 1.0237-0.39052 1.4142 0"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m15.707 7.7929c0.39052 0.39052 0.39052 1.0237 0 1.4142-0.39052 0.39052-1.0237 0.39052-1.4142 0-0.39052-0.39052-0.39052-1.0237 0-1.4142 0.39052-0.39052 1.0237-0.39052 1.4142 0"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m21.707 0.79289c0.39052 0.39052 0.39052 1.0237 0 1.4142-0.39052 0.39052-1.0237 0.39052-1.4142 0-0.39052-0.39052-0.39052-1.0237 0-1.4142 0.39052-0.39052 1.0237-0.39052 1.4142 0"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m3.77 10.86l4.46-3.72"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="m9.94 6.82l4.14 1.37" stroke="#05B87F" strokeLinejoin="round" />
      <path
        d="m20.35 2.26l-4.7 5.48"
        stroke="#05B87F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/page-usage.es6.js